var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto px-4 pb-12 sm:px-4 lg:px-8"},[_c('div',{staticClass:"flex justify-between"},[_c('h3',{staticClass:"text-2xl font-semibold leading-6 text-gray-900"},[_vm._v(" Selamat Datang, "+_vm._s(_vm.me.name)+" ")]),_c('span',[_vm._v(_vm._s(_vm.date))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }